import { BaseRecord } from '@refinedev/core';
import { create } from 'zustand';

export interface STTTokenStoreConfig {
  storageKey: string;
}

export interface STTTokenState extends BaseRecord {
  sttToken: string | null;
  sttTokenExpirationTime: number | null;
  loading: boolean;
  error: null;
}

interface STTTokenActions {
  setSTTToken: (token: string, expirationTime: number) => void;
}

type STTTokenStore = STTTokenState & STTTokenActions & { config: STTTokenStoreConfig };

export const sttTokenStoreConfig: STTTokenStoreConfig = {
  storageKey: 'sttTokenState',
};

export const useSTTTokenStore = create<STTTokenStore>((set) => ({
  sttToken: null,
  sttTokenExpirationTime: null,
  loading: false,
  error: null,
  config: sttTokenStoreConfig,
  setSTTToken: (token: string, expirationTime: number) =>
    set({ sttToken: token, sttTokenExpirationTime: expirationTime }),
}));

export default useSTTTokenStore;
